import Api from '@/services/api.js'

export default {
  addApprovedBillLine(approvedBillLine) {
    return Api.post('approvedBillLines/add', approvedBillLine)
  },
  addBills(payload) {
    return Api.post('approvedBillLines/createBills', payload)
  },
  updateApprovedBillLine(id, payload) {
    return Api.put(`approvedBillLines/${id}`, payload)
  },
  getApprovedBillLines(payload) {
    return Api.post(`approvedBillLines/get`, payload)
  },
  deleteApprovedBillLine(id) {
    return Api.delete(`approvedBillLines/${id}`)
  },
  deleteMultipleApprovedBillLines(payload) {
    return Api.post('approvedBillLines/deleteMultiple', payload)
  },

  importApprovedBillLines(file) {
    return Api.post('approvedBillLines/import', file)
  },
  getApprovedBillLinesByIds(body) {
    return Api.post('approvedBillLines/lines/get', body)
  },
  getApprovedBillLinesByBillingPeriod(billingPeriod) {
    return Api.get(`approvedBillLines/byBillingPeriod/${billingPeriod}`)
  },
  getApprovedBillLinesByBill(id) {
    return Api.get(`approvedBillLines/byBill/${id}`)
  }
}
